import KeywordAnalysisService from '../../services/KeywordAnalysisService';

export const namespaced = true;

export const state = {
  keywordAnalysis: null,
  desiredTime: 0,
};

export const mutations = {
  SET_KEYWORD_ANALYSIS(state, keywordAnalysis) {
    state.keywordAnalysis = keywordAnalysis;
  },
  SET_DESIRED_TIME(state, desiredTime) {
    state.desiredTime = desiredTime;
  },
};

export const actions = {
  getKeywordAnalysisForJob({ commit }, jobId) {
    return KeywordAnalysisService.getKeywordAnalysisForJob(jobId)
      .then(({ data }) => {
        commit('SET_KEYWORD_ANALYSIS', data);
        return data;
      });
  },
  setDesiredTime({ commit }, desiredTime) {
    commit('SET_DESIRED_TIME', desiredTime);
  },
};

export const getters = {};
